/* eslint-disable max-len */
import { usersList } from "./apiSlice";

const organizationUserList=usersList.injectEndpoints({
    tagTypes:['OrgUser','SubDiv','SelectedOrgUserOrg','OrgUserActivityHistory','OrgUserHistoryExport'],
    endpoints:(builder)=>({

        addOrganizationUser:builder.mutation({
            query:org=>({
                url:`organization-users`,
                method:'POST',
                body:org
            }),
            invalidatesTags:['OrgUser','SubDiv']
        }),

        getSubDiv: builder.query({
            query: (searchParams) => `organizations/list-subdivisions?${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                
                'SubDiv',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'SubDiv', id:_id}))
            ]:[] 
        }),

        getOrganizationUser: builder.query({
            query: (searchParams) => `organization-users?${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[      
                'OrgUser',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'OrgUser', id:_id}))
            ]:[],
            
        }),

        getUsersSubDiv: builder.query({
            query: (searchParams) => `organization-users/list-subdivisions?${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[   
                'SubDivUser',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'SubDivUser', id:_id}))
            ]:[]
  
        }),

        viewOrganizationUser:builder.query({
            query:(id)=>`/organization-users/${id}`,
            providesTags: (result, error, arg) => [{ type: 'OrgUser', id: arg?.split('?')[0]  }]
        }),
        viewWebsocketOrganizationUser:builder.query({
            query:(id)=>`/organization-users/${id}`,
            providesTags: (result, error, arg) => [{ type: 'OrgUser', id: arg?.split('?')[0]  }]
        }),

        exportOrganizationUsers:builder.mutation({
            query:({queryString,columns,dateformat})=>({
                url:`organization-users/export-organizationuser-list?${queryString}`,
                method:'POST',
                body:{"columns":columns,"dateformat":dateformat,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone}
            }),
        }),

        exportSubdivision:builder.mutation({
            query:({queryString,columns})=>({
                url:`organization-users/export-subdivisions-list?${queryString}`,
                method:'POST',
                body:{"columns":columns,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone}
            }),
        }),

        editOrgUser:builder.mutation({
            query:({id,body})=>({
                url:id!==undefined?`/organization-users/${id}`:`/organization-users/`,
                method:'PATCH',
                body:body
            }),
            invalidatesTags:(result,error,arg)=>[{type:'OrgUser',id:arg.id}]
        }),

        getOrgUserSubdivisions:builder.query({
            query: (searchParams) => `organization-users/list-subdivisions?${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                'SelectedOrgUserOrg',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'SelectedOrg', id:_id}))
            ]:[], 
        }),

        linkOrgUsertoOrganization: builder.mutation({
            query: ({userId,body}) => ({
                url: `organization-users/link-subdivisions/${userId}`,
                method: 'POST',
                body:body
            }),
            invalidatesTags: ['SelectedOrgUserOrg']
        }),


        deleteOrgUserAssociatedOrganization: builder.mutation({
            query: ({userId,subdivision_id}) => {
                return {
                    url: `organization-users/unlink-subdivisions/${userId}?subdivision_id=${subdivision_id}`,
                    method: 'DELETE',
                };
            },
            invalidatesTags: ['SelectedOrgUserOrg'],
        }),
        getOrgUserActivityHistory: builder.query({
            query: (searchParams) => `organization-users/list-changes?${searchParams}`,
            providesTags: ['OrgUserActivityHistory']

        }),
        exportOrgUserActivityHistory:builder.mutation({
            query:({sort,columns,username,dateformat ,params})=>{
                const queryParams = Object.entries(params)
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join('&');
                return{
                    url:`organization-users/export-profile-changes?${queryParams}`,
                    method:'POST',
                    body:{"columns":columns,"target_user_name":username,"dateformat":dateformat, "timezone":Intl.DateTimeFormat().resolvedOptions().timeZone }
                };
            },
        }),
        getOrgUserViewExportHistory: builder.query({
            query: (searchParams) => `organization-users/list-export-history?${searchParams}`,
            providesTags: ['OrgUserHistoryExport']
        }),
        exportOrgUserExportLog:builder.mutation({
            query:({columns,dateformat,username})=>({
                url:`organization-users/export-export-history
                `,
                method:'POST',
                body:{"columns":columns,"dateformat":dateformat,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone,"target_user":username}
            }),
        }), 

    }),
    overrideExisting: false
})


export const {useLazyGetSubDivQuery,
    useGetOrgUserViewExportHistoryQuery,
    useExportOrgUserExportLogMutation,
    useLinkOrgUsertoOrganizationMutation,
    useLazyGetOrgUserSubdivisionsQuery,
    useLazyViewOrganizationUserQuery,
    useGetUsersSubDivQuery,
    useExportSubdivisionMutation,
    useExportOrganizationUsersMutation,
    useAddOrganizationUserMutation,
    useGetSubDivQuery,
    useGetOrganizationUserQuery,
    useViewOrganizationUserQuery,
    useEditOrgUserMutation,
    useDeleteOrgUserAssociatedOrganizationMutation,
    useGetOrgUserActivityHistoryQuery,
    useExportOrgUserActivityHistoryMutation,
    useLazyViewWebsocketOrganizationUserQuery
}=organizationUserList